exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading .dynamic {\n  background: #FF750F !important;\n}\n.clauseDiv .green {\n  font-family: PingFangSC-Regular;\n  font-size: 0.6rem;\n  color: #A57E48 !important;\n  line-height: 0.6rem;\n  font-weight: 400;\n}", ""]);

// exports
